<template>
  <label class="switch">
    <input
      type="checkbox"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <span class="switch-slider"></span>
  </label>
</template>

<script>
export default {
  name: "ToggleSwitch",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
/* Fixed width for consistent toggle size */
.switch {
  display: inline-block;
  position: relative;
  min-width: 42px;
  max-width: 42px;
  width: 42px;
  height: 24px;
  box-sizing: border-box;
}
.switch input {
  display: none;
}
.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--surface-light);
  border: 1px solid var(--border);
  transition: 0.2s;
  border-radius: 999px;
}
.switch-slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--white);
  border-radius: 50%;
  transition: 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
.switch input:checked + .switch-slider {
  background-color: var(--primary_color);
  border-color: var(--primary_color);
}
.switch input:checked + .switch-slider:before {
  transform: translateY(-50%) translateX(18px);
}
</style>
